<template>
  <div>
    <el-steps :active='step' :space="200" simple>
      <el-step v-for="(s, i) in steps" :icon="i === 0 ? 'el-icon-edit' : 'el-icon-tickets'" :key="i"
        :title="i === 0 ? 'Gestión de riesgos' : 'Procedimiento de trabajo'" :description="$t(s)"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'StepsInventario',
  props: [
    'step',
  ],
  computed: {
    role() { return this.$store.getters.role; },
    mel() { return this.role.faena_id === '5a6f78337b772dcfe68241d5'; },
    steps() {
      return this.mel
        ? ['Selección Riesgos', 'Resumen']
        : ['Selección Riesgos', 'Definición Procedimiento', 'Resumen'];
    },
  },
};
</script>

<style scoped>
</style>

<style>
.el-step__title {
  font-size: 14px !important;
}
</style>